import { FormSelect, FormSelectProps } from '@tcc-online/input-components';
import { useTranslate } from 'react-translate.ts';
import { TRANSLATIONS_ROOT_KEY } from '../../constants/translation.constants';

export default function UserRoleSelect(
    props: Omit<
        FormSelectProps<{ value: string; label: string; disabled: boolean }>,
        'options'
    >,
) {
    const translate = useTranslate(TRANSLATIONS_ROOT_KEY + '.user.role');

    return (
        <FormSelect
            name={props.name}
            label={translate('title')}
            options={[
                {
                    value: 'super_admin',
                    label: translate('super-admin'),
                },
                { value: 'admin', label: translate('admin') },
            ]}
        />
    );
}
